<template>
  <div class="h-100">
    <Layout ref="layout">
      <template v-slot:body>
        <div>
          <h3>Alerta</h3>
          <Tab
            :values="[
              { name: 'Histórico de Alertas', slot: 'historico' },
              { name: 'Cadastrar Alertas', slot: 'cadastro' },
            ]"
            @tabchange="forceRerenderTab"
            ref="tab"
          >
            <template v-slot:historico>
              <!-- Histórico de alertas -->
              <div class="page-container">
                <div>
                  <div class="section">
                    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
                      <div>
                        <h2>Histórico de Alertas</h2>
                        <p>Lista de alertas recebidos.</p>
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="marcarTodasComoLidas"
                        :disabled="marcandoTodas"
                      >
                        <i class="bx bx-check-double me-1"></i> Marcar todas como lidas
                      </button>
                    </div>

                    <Datatable
                      v-if="tabComponent"
                      ref="datatableHistorico"
                      :fields="fieldsHistorico"
                      url="/UserInfoAlertHistory/Read"
                      @delete="deleteHistoricoAlerta"
                      :where="where"
                      :iniorderby="{ column: 'triggeredAt', type: 'DESC' }"
                      :mobileCardMode="true"
                      :selectable="true"
                      :bulk-actions="bulkActionsConfig"
                      @bulk-delete="onBulkDeleteHistorico"
                      @loaded="onHistoricoCarregado"
                    >
                      <template v-slot:empty>
                        <div class="text-center my-5">
                          <p>Falha ao buscar</p>
                          <button @click="$refs.datatableHistorico.update()" class="btn btn-success">
                            Recarregar
                          </button>
                        </div>
                      </template>
                    </Datatable>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cadastro>
              <!-- Cadastro de alertas -->
              <div class="page-container">
                <div class="section">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h2>Gerenciar Alertas</h2>
                    <div>
                      <!-- <button
                        class="btn btn-primary mx-1"
                        @click="openFilter"
                        title="Filtros"
                      >
                        <i class="menu-icon tf-icons bx bx-filter-alt m-0"></i>
                      </button> -->
                      <button
                        class="btn btn-primary"
                        @click="createAlert"
                        title="Criar novo alerta"
                      >
                        Novo Alerta
                      </button>
                    </div>
                  </div>
                  
                  <Datatable
                    v-if="tabComponent"
                    ref="datatableCadastro"
                    :fields="fieldsCadastro"
                    url="/UserInfoAlert/Read"
                    @edit="editAlert"
                    @delete="deleteAlert"
                    @toggle-event="toggleAlertStatus"
                    :where="whereFilters"
                    :iniorderby="{ column: 'created', type: 'DESC' }"
                    :mobileCardMode="true"
                    :selectable="true"
                    :bulk-actions="bulkActionsConfig"
                    @bulk-delete="onBulkDeleteAlert"
                  >
                    <template v-slot:empty>
                      <div class="text-center my-5">
                        <p>Falha ao buscar</p>
                        <button @click="$refs.datatableCadastro.update()" class="btn btn-success">
                          Recarregar
                        </button>
                      </div>
                    </template>
                  </Datatable>
                </div>
              </div>
            </template>
          </Tab>
        </div>
      </template>
    </Layout>

    <!-- Modal de Form -->
    <div class="modal fade" ref="modal_form" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary pb-3">
            <h5 class="modal-title text-white">
              {{ editId ? "Editar" : "Criar" }} Alerta
            </h5>
            <button type="button" class="btn-close" @click="closeForm" :disabled="isLoading"></button>
          </div>
          <div class="modal-body form-modal-body">
            <AlertaForm 
              :form="{ crud: { form: alertForm } }" 
              :propriedades="propriedades"
              :dispositivos="dispositivos"
              :is-submitting="isLoading"
              @load-dispositivos="loadDispositivosByPropriedade"
              @load-shared-dispositivos="loadSharedDispositivos"
              ref="alertaForm" 
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeForm"
              :disabled="isLoading"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId"
              @click="doUpdate"
              :disabled="isLoading"
            >
              <div
                class="spinner-border spinner-border-sm text-white me-2"
                role="status"
                v-if="isLoading"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              {{ isLoading ? "Salvando..." : "Salvar" }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="doCreate"
              :disabled="isLoading"
            >
              <div
                class="spinner-border spinner-border-sm text-white me-2"
                role="status"
                v-if="isLoading"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              {{ isLoading ? "Criando..." : "Criar" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Filtros -->
    <div class="modal fade" ref="modal_filter" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary pb-3">
            <h5 class="modal-title text-white">Filtrar Alertas</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeFilter"
            ></button>
          </div>
          <div class="modal-body form-modal-body">
            <div>
              <div class="mb-3">
                <label class="form-label">Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filters.nome"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Propriedade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filters.propriedade"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="clearFilters"
            >
              Limpar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="applyFilters"
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmacao de Exclusao -->
    <div class="modal fade" tabindex="-1" ref="modal_delete">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white mb-2">
              {{ deleteModalTitle }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="cancelDelete"
            ></button>
          </div>
          <div class="modal-body">
            <!-- Mensagem para exclusão de alerta -->
            <span v-if="deleteType === 'alert' && deleteUserAlertName">
              Deseja realmente excluir o alerta "<strong>{{ deleteUserAlertName }}</strong>"?
            </span>
            <span v-else-if="deleteType === 'alert'">
              Deseja realmente excluir este alerta?
            </span>

            <!-- Mensagem para exclusão de histórico -->
            <span v-else-if="deleteType === 'historico' && deleteHistoricoItemName">
              Deseja realmente excluir o histórico do alerta "<strong>{{ deleteHistoricoItemName }}</strong>"?
            </span>
            <span v-else-if="deleteType === 'historico'">
              Deseja realmente excluir este histórico?
            </span>

            <!-- Mensagens para exclusão em lote -->
            <span v-else-if="deleteType === 'bulk-alert'">
              Deseja realmente excluir <strong>{{ bulkDeleteIds.length }}</strong>
              {{ bulkDeleteIds.length === 1 ? 'alerta selecionado' : 'alertas selecionados' }}?
              Esta ação não pode ser desfeita.
            </span>
            <span v-else-if="deleteType === 'bulk-historico'">
              Deseja realmente excluir <strong>{{ bulkDeleteIds.length }}</strong>
              {{ bulkDeleteIds.length === 1 ? 'item do histórico' : 'itens do histórico' }}?
              Esta ação não pode ser desfeita.
            </span>

            <!-- Generico -->
            <span v-else>
              Deseja realmente excluir este item?
            </span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="cancelDelete"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="confirmDelete"
              :disabled="isLoading"
            >
              <div
                class="spinner-border spinner-border-sm text-white me-2"
                role="status"
                v-if="isLoading"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              {{ isLoading ? "Excluindo..." : "Excluir" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <Alert ref="alert"></Alert>
  </div>
</template>

<script>
import Datatable from "../../components/crud/Datatable.vue";
import Layout from "../../components/layout/Tema.vue";
import Alert from "../../components/Alert.vue";
import Tab from "../../components/form/Tab.vue";
import AlertaForm from "../../components/form/AlertaForm.vue";

export default {
  components: {
    Layout,
    Tab,
    Datatable,
    Alert,
    AlertaForm
  },
  data() {
    return {
      tabComponent: true,
      // Só marca como lido o que foi carregado com a aba Histórico aberta.
      abaAtiva: "historico",
      marcandoTodas: false,
      userId: null,
      isLoading: false,
      editId: null,
      deleteUserAlertId: null,
      deleteUserAlertName: null,
      deleteHistoricoId: null,
      deleteHistoricoItemName: null,
      deleteType: null,
      bulkDeleteIds: [],
      bulkActionsConfig: [
        {
          label: "Excluir selecionados",
          icon: "bx-trash",
          event: "bulk-delete",
          variant: "danger",
        },
      ],
      alertForm: {},
      filters: {},
      whereFilters: {},
      propriedades: [],
      dispositivos: [],
      fieldsHistorico: [
        {
          name: "Data do disparo",
          value: "triggeredAt",
          format: (v, d) => {
            if (v != null) {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "-";
            }
          },
          style: { textAlign: "center", width: "200px" }
        },
        {
          name: "Nome",
          value: "userInfoAlertName",
          // isRead vem como estava ao carregar a página: o selo fica visível nesta visita
          // mesmo depois de a página ser marcada como lida.
          format: (v, d) => {
            const nome = (v || "-").replace(/&/g, "&amp;").replace(/</g, "&lt;");
            return d.isRead === false ? `<span class="badge bg-label-primary me-1">Nova</span>${nome}` : nome;
          },
          style: { width: "200px" }
        },
        {
          name: "Mensagem",
          value: "message",
          orderby: false,
          format: (v) => (v || "-").replace(/&/g, "&amp;").replace(/</g, "&lt;"),
          style: { minWidth: "260px" }
        },
        { name: "Dispositivo", value: "deviceName", orderby: false, style: { width: "180px" } },
        {
          name: "Propriedade",
          value: "propertyName",
          orderby: false,
          format: (v, d) => {
            return d.isSharedDevice ? "Compartilhado Comigo" : (v || "-");
          },
          style: { width: "200px" }
        },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "action",
          edit: false,
          delete: true,
          style: { width: "80px", minWidth: "80px", textAlign: "center" },
        },
      ],
      fieldsCadastro: [
        {
          name: "Status",
          value: "active",
          type: "toggle",
          style: { width: "80px", textAlign: "center" },
          toggleEvent: "toggle-event"
        },
        { name: "Nome", value: "name", style: { width: "200px" } },
        {
          name: "Propriedade",
          value: "propertyName",
          orderby: false,
          format: (v, d) => {
            return d.isSharedDevice ? "Compartilhado Comigo" : (v || "-");
          },
          style: { width: "200px" }
        },
        { name: "Dispositivo", value: "deviceName", orderby: false, style: { width: "180px" } },
        {
          name: "Data de Criação",
          value: "created",
          format: (v, d) => {
            if (v != null) {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "-";
            }
          },
          style: { textAlign: "center", width: "200px" }
        },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "action",
          edit: true,
          delete: true,
          style: { width: "100px", minWidth: "100px", textAlign: "center" },
        },
      ],
      where: {}
    };
  },
  async created() {
    const user = this.getUser();
    if (user && user.id) {
      this.userId = user.id;
    }

    await this.carregarPropriedades();

    // Chega pelo botão "cadastrar alerta" do aside de dispositivo (mapa):
    // já abre o form de novo alerta pré-preenchido com o dispositivo/sensor.
    this.applyPrefillFromQuery();
  },
  computed: {
    isAdmin() {
      return this.userLevel(10);
    },
    deleteModalTitle() {
      switch (this.deleteType) {
        case "historico":
        case "bulk-historico":
          return "Deletar Histórico";
        case "alert":
        case "bulk-alert":
          return "Deletar Alerta";
        default:
          return "Deletar";
      }
    },
  },
  methods: {
    // Página do histórico carregada = vista: marca como lido o que ainda não estava.
    onHistoricoCarregado(itens) {
      if (this.abaAtiva !== "historico") return;
      const ids = (itens || []).filter((i) => i.isRead === false).map((i) => i.id);
      if (ids.length === 0) return;
      this.urlPost("/UserInfoAlertHistory/MarkAsRead", { ids })
        .then(() => this.globalEvent("alertas_nao_lidas"))
        .catch(() => {});
    },
    marcarTodasComoLidas() {
      this.marcandoTodas = true;
      this.urlPost("/UserInfoAlertHistory/MarkAllAsRead")
        .then(() => {
          this.globalEvent("alertas_nao_lidas");
          this.$refs.datatableHistorico && this.$refs.datatableHistorico.update();
        })
        .catch(() => {
          this.$refs.alert.show("Erro", "Não foi possível marcar como lidas.", null, 5000, "bg-danger");
        })
        .finally(() => {
          this.marcandoTodas = false;
        });
    },
    forceRerenderTab(aba) {
      if (aba) this.abaAtiva = aba;
      this.tabComponent = false;
      this.$nextTick(() => {
        this.tabComponent = true;
      });
    },

    // Prefill vindo do aside de dispositivo de terceiros (?externalDeviceId&externalId&fonte).
    // Liga a origem 'terceiros' no AlertaForm, que troca propriedade/dispositivo pelos
    // selects de Órgão e estação — que ele mesmo pré-seleciona a partir destes valores.
    async applyExternalPrefill(q) {
      if (this.$refs.tab) {
        this.$refs.tab.active = 1;
      }

      this.editId = null;
      this.dispositivos = [];
      this.alertForm = {};
      this.initializeForm();

      this.alertForm.origem = 'terceiros';
      this.alertForm.propriedadeId = '';
      this.alertForm.isSharedDevice = false;
      this.alertForm.externalDeviceId = !isNaN(Number(q.externalDeviceId))
        ? Number(q.externalDeviceId)
        : q.externalDeviceId;
      if (q.externalId) this.alertForm.externalId = q.externalId;
      if (q.fonte) this.alertForm.fonte = q.fonte;
      if (q.nomeDispositivo) this.alertForm.nomeDispositivo = q.nomeDispositivo;

      await this.$nextTick();
      this.openForm();

      // Aguarda o modal montar e manda o AlertaForm resolver fonte/estação e os fields.
      await new Promise(resolve => setTimeout(resolve, 100));
      if (this.$refs.alertaForm) {
        this.$refs.alertaForm.syncSelectedObjects();
      }
    },

    // Pré-preenche o formulário de novo alerta quando o usuário chega pelo botão
    // "cadastrar alerta" do aside de dispositivo (mapa). Os parâmetros trazem a
    // propriedade, o módulo (qrCodeId), o sensor e o sourceId selecionados.
    async applyPrefillFromQuery() {
      const q = this.$route && this.$route.query ? this.$route.query : {};

      // Vindo do aside de dispositivo de terceiros: outro conjunto de parâmetros.
      if (q.externalDeviceId) {
        await this.applyExternalPrefill(q);
        return;
      }

      if (!q.qrCodeId) return;

      // Vai para a aba "Cadastrar Alertas".
      if (this.$refs.tab) {
        this.$refs.tab.active = 1;
      }

      // Dispositivo compartilhado comigo: a propriedade real é do dono e não
      // aparece na minha lista. Uso a opção "Compartilhados Comigo" ('shared'),
      // que o backend traduz para propertyId=-1 no submit do alerta.
      const isShared = q.shared === '1' || q.shared === 1;
      const propriedadeId = isShared
        ? 'shared'
        : (q.propriedadeId != null && !isNaN(Number(q.propriedadeId))
            ? Number(q.propriedadeId)
            : q.propriedadeId);
      const qrCodeId = !isNaN(Number(q.qrCodeId)) ? Number(q.qrCodeId) : q.qrCodeId;

      // Monta o form de novo alerta já com propriedade, dispositivo e sensor.
      this.editId = null;
      this.dispositivos = [];
      this.alertForm = {};
      this.initializeForm();
      this.alertForm.propriedadeId = propriedadeId;
      this.alertForm.isSharedDevice = isShared;
      this.alertForm.dispositivoId = qrCodeId;
      if (q.sensor) this.alertForm.sensorName = q.sensor;
      if (q.sourceId != null && q.sourceId !== '') {
        this.alertForm.sourceId = isNaN(Number(q.sourceId)) ? q.sourceId : Number(q.sourceId);
      }

      // Carrega os dispositivos: compartilhados comigo (SharedLinked) quando o
      // dispositivo é compartilhado, ou os da propriedade (Linked) caso contrário.
      if (isShared) {
        await this.loadSharedDispositivos();
      } else if (propriedadeId != null) {
        await this.loadDispositivosByPropriedade(propriedadeId);
      }

      await this.$nextTick();

      this.openForm();

      // Aguarda o modal abrir e força o AlertaForm a sincronizar os objetos
      // selecionados; ele carrega os sensores do módulo e seleciona o sensorName.
      await new Promise(resolve => setTimeout(resolve, 100));
      if (this.$refs.alertaForm) {
        this.$refs.alertaForm.syncSelectedObjects();
      }
    },

    createAlert() {
      this.editId = null;
      this.alertForm = {};
      this.dispositivos = []; // Limpar dispositivos
      this.initializeForm();
      this.openForm();
    },

    async editAlert(data) {
      this.editId = data.id;
      this.dispositivos = []; // Limpar dispositivos anteriores
      this.alertForm = Object.assign({}, data);
      this.prepareFormForEdit();

      // Carregar dispositivos antes de abrir o modal. Alerta de terceiros não usa a lista de
      // dispositivos da propriedade — o AlertaForm carrega fonte/estação por conta própria.
      if (this.alertForm.externalDeviceId) {
        // nada a carregar aqui
      } else if (this.alertForm.isSharedDevice || this.alertForm.propriedadeId === 'shared') {
        await this.loadSharedDispositivos();
      } else if (this.alertForm.propriedadeId) {
        await this.loadDispositivosByPropriedade(this.alertForm.propriedadeId);
      }

      // Aguardar para garantir que tudo está pronto
      await this.$nextTick();
      await this.$nextTick();

      // Abrir modal
      this.openForm();

      // Aguardar o modal abrir completamente
      await new Promise(resolve => setTimeout(resolve, 100));

      // Forçar sincronização dos objetos selecionados no componente filho
      if (this.$refs.alertaForm) {
        this.$refs.alertaForm.syncSelectedObjects();
      }
    },

    initializeForm() {
      this.alertForm.nome = "";
      this.alertForm.status = "ATIVO";
      this.alertForm.ativo = true;
      this.alertForm.alertType = "";
      this.alertForm.alertFrequency = "";
      this.alertForm.propriedadeId = "";
      this.alertForm.dispositivoId = "";
      this.alertForm.sensorName = "";
      this.alertForm.sourceId = null;
      // Dispositivo de terceiros (Defesa Civil / ANA / ...). 'origem' escolhe qual metade
      // do formulário aparece; novo alerta começa no fluxo OnAgro.
      this.alertForm.origem = "onagro";
      this.alertForm.fonte = null;
      this.alertForm.externalDeviceId = null;
      this.alertForm.externalId = null;
      this.alertForm.condicoes = [{
        dataToAlert: '',
        operator: '',
        value: '',
        unit: ''
      }];
    },

    prepareFormForEdit() {

      if (this.alertForm.name && !this.alertForm.nome) {
        this.alertForm.nome = this.alertForm.name;
      }

      // Alerta de dispositivo de terceiros: liga a origem e resolve o órgão a partir do
      // campo externalFonte devolvido pela query.
      if (this.alertForm.externalDeviceId) {
        this.alertForm.origem = 'terceiros';
        this.alertForm.propriedadeId = '';
        this.alertForm.isSharedDevice = false;
        if (this.alertForm.externalFonte && !this.alertForm.fonte) {
          this.alertForm.fonte = this.alertForm.externalFonte;
        }
      } else if (this.alertForm.isSharedDevice) {
        this.alertForm.propriedadeId = 'shared';
      } else if (this.alertForm.propertyId && !this.alertForm.propriedadeId) {
        this.alertForm.propriedadeId = this.alertForm.propertyId;
      }

      if (this.alertForm.deviceId && !this.alertForm.dispositivoId) {
        this.alertForm.dispositivoId = this.alertForm.deviceId;
      }

      // Converter alertFrequency e alertType para número
      if (this.alertForm.alertFrequency !== undefined && this.alertForm.alertFrequency !== null) {
        this.alertForm.alertFrequency = Number(this.alertForm.alertFrequency);
      }

      if (this.alertForm.alertType !== undefined && this.alertForm.alertType !== null) {
        this.alertForm.alertType = Number(this.alertForm.alertType);
      }

      if (!this.alertForm.condicoes) {
        this.alertForm.condicoes = [];
      }

      if (this.alertForm.conditions && Array.isArray(this.alertForm.conditions) && this.alertForm.conditions.length > 0) {
        this.alertForm.condicoes = this.alertForm.conditions.map(c => ({
          dataToAlert: c.dataToAlert !== undefined ? Number(c.dataToAlert) : '',
          operator: c.operator !== undefined ? Number(c.operator) : '',
          value: c.value !== undefined ? Number(c.value) : '',
          unit: c.unit !== undefined ? Number(c.unit) : ''
        }));
      }

      if (!this.alertForm.condicoes.length) {
        this.alertForm.condicoes = [{
          dataToAlert: '',
          operator: '',
          value: '',
          unit: ''
        }];
      }
    },

    openForm() {
      $(this.$refs.modal_form).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeForm() {
      if (!this.isLoading) {
        // Resetar o formulário antes de fechar
        if (this.$refs.alertaForm) {
          this.$refs.alertaForm.resetForm();
        }
        this.dispositivos = []; // Limpar lista de dispositivos
        this.editId = null; // Limpar editId
        $(this.$refs.modal_form).modal("hide");
      }
    },

    doCreate() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;
      const dadosParaEnvio = this.prepareDataForSubmit();

      this.urlPost("/UserInfoAlert", dadosParaEnvio)
        .then((res) => {
          this.isLoading = false;
          this.$refs.alert.show(
            "Criado",
            "O alerta foi criado com sucesso!",
            null,
            5000,
            "bg-success"
          );
          this.closeForm();
          this.$refs.datatableCadastro.update();
        })
        .catch((e) => {
          console.error("Erro ao criar alerta:", e);
          this.isLoading = false;
          this.$refs.alert.show(
            "Erro",
            "Não foi possível criar o alerta!",
            null,
            5000,
            "bg-danger"
          );
        });
    },

    doUpdate() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;
      const dadosParaEnvio = this.prepareDataForSubmit();
      dadosParaEnvio.id = this.editId;

      this.urlPut(`/UserInfoAlert/${this.editId}`, dadosParaEnvio)
        .then((res) => {
          this.isLoading = false;
          this.$refs.alert.show(
            "Atualizado",
            "O alerta foi atualizado com sucesso!",
            null,
            5000,
            "bg-success"
          );
          this.closeForm();
          this.$refs.datatableCadastro.update();
        })
        .catch((e) => {
          console.error("Erro ao atualizar alerta:", e);
          this.isLoading = false;
          this.$refs.alert.show(
            "Erro",
            "Não foi possível atualizar o alerta!",
            null,
            5000,
            "bg-danger"
          );
        });
    },

    validateForm() {
      if (!this.$refs.alertaForm) {
        this.$refs.alert.show("Erro", "Formulário não encontrado", null, 3000, "bg-danger");
        return false;
      }

      return this.$refs.alertaForm.validateForm();
    },

    prepareDataForSubmit() {
      const userId = this.getUserId();
      var propertyToSubmit;
      var isSharedDevice = false;

      // Dispositivo de terceiros: não tem propriedade nem QRCode — o vínculo é só o
      // externalDeviceId, e o backend ignora os demais campos de dispositivo.
      if (this.alertForm.origem === 'terceiros') {
        return {
          userId: parseInt(userId),
          externalDeviceId: Number(this.alertForm.externalDeviceId),
          name: this.alertForm.nome,
          alertType: Number(this.alertForm.alertType),
          alertFrequency: Number(this.alertForm.alertFrequency),
          active: true,
          conditions: this.alertForm.condicoes.map(condicao => ({
            dataToAlert: Number(condicao.dataToAlert),
            operator: Number(condicao.operator),
            value: parseFloat(condicao.value),
            unit: Number(condicao.unit),
            period: this.alertForm.alertFrequency
          }))
        };
      }

      if (this.alertForm.propriedadeId === 'shared') {
       propertyToSubmit = -1;
       isSharedDevice = true;
      } else {
        propertyToSubmit = parseInt(this.alertForm.propriedadeId);
      }

      const dadosParaEnvio = {
        userId: parseInt(userId),
        propertyId: propertyToSubmit,
        deviceId: parseInt(this.alertForm.dispositivoId),
        name: this.alertForm.nome,
        alertType: Number(this.alertForm.alertType),
        alertFrequency: Number(this.alertForm.alertFrequency),
        active: true,
        isSharedDevice: isSharedDevice,
        sensorName: this.alertForm.sensorName || null,
        sourceId: this.alertForm.sourceId || null,
        conditions: this.alertForm.condicoes.map(condicao => ({
          dataToAlert: Number(condicao.dataToAlert),
          operator: Number(condicao.operator),
          value: parseFloat(condicao.value),
          unit: Number(condicao.unit),
          period: this.alertForm.alertFrequency
        }))
      };

      return dadosParaEnvio;
    },

    getUserId() {
      const user = this.getUser();
      return user ? user.id : null;
    },

    deleteAlert(id) {
      const item = this.$refs.datatableCadastro.values.find(v => v.id === id);
      
      this.deleteUserAlertId = id;
      this.deleteUserAlertName = item ? (item.name || item.nome) : null;
      this.deleteType = 'alert';
      
      $(this.$refs.modal_delete).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    confirmDelete() {
      if (this.deleteType === 'historico' && this.deleteHistoricoId) {
        this.isLoading = true;

        this.urlDelete(`/UserInfoAlertHistory/${this.deleteHistoricoId}`)
          .then(() => {
            this.$refs.alert.show(
              "Sucesso",
              "Alerta removido do histórico com sucesso",
              null,
              3000,
              "bg-success"
            );
            this.$refs.datatableHistorico.update();
          })
          .catch((error) => {
            console.error("Erro ao excluir alerta do histórico:", error);
            this.$refs.alert.show(
              "Erro",
              "Erro ao excluir alerta do histórico",
              null,
              3000,
              "bg-danger"
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.cancelDelete();
          });

      } else if (this.deleteType === 'alert' && this.deleteUserAlertId) {
        this.isLoading = true;

        this.urlDelete(`/UserInfoAlert/${this.deleteUserAlertId}`)
          .then(() => {
            this.$refs.alert.show(
              "Excluído",
              "Alerta excluído com sucesso",
              null,
              3000,
              "bg-success"
            );
            this.$refs.datatableCadastro.update();
          })
          .catch((error) => {
            console.error("Erro ao excluir alerta:", error);
            this.$refs.alert.show(
              "Erro",
              "Erro ao excluir alerta",
              null,
              3000,
              "bg-danger"
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.cancelDelete();
          });
      } else if (this.deleteType === 'bulk-alert' && this.bulkDeleteIds.length > 0) {
        this.isLoading = true;

        this.urlDelete('/UserInfoAlert/bulk', { ids: this.bulkDeleteIds })
          .then((res) => {
            const count = (res && res.data && res.data.deleted) || this.bulkDeleteIds.length;
            this.$refs.alert.show(
              "Excluído",
              `${count} ${count === 1 ? 'alerta excluído' : 'alertas excluídos'} com sucesso`,
              null,
              3000,
              "bg-success"
            );
            this.$refs.datatableCadastro.clearSelection();
            this.$refs.datatableCadastro.update();
          })
          .catch((error) => {
            console.error("Erro ao excluir alertas em lote:", error);
            this.$refs.alert.show(
              "Erro",
              "Erro ao excluir alertas selecionados",
              null,
              3000,
              "bg-danger"
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.cancelDelete();
          });
      } else if (this.deleteType === 'bulk-historico' && this.bulkDeleteIds.length > 0) {
        this.isLoading = true;

        this.urlDelete('/UserInfoAlertHistory/bulk', { ids: this.bulkDeleteIds })
          .then((res) => {
            const count = (res && res.data && res.data.deleted) || this.bulkDeleteIds.length;
            this.$refs.alert.show(
              "Sucesso",
              `${count} ${count === 1 ? 'item removido' : 'itens removidos'} do histórico`,
              null,
              3000,
              "bg-success"
            );
            this.$refs.datatableHistorico.clearSelection();
            this.$refs.datatableHistorico.update();
          })
          .catch((error) => {
            console.error("Erro ao excluir histórico em lote:", error);
            this.$refs.alert.show(
              "Erro",
              "Erro ao excluir itens do histórico",
              null,
              3000,
              "bg-danger"
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.cancelDelete();
          });
      }
    },

    cancelDelete() {
      this.deleteUserAlertId = null;
      this.deleteUserAlertName = null;
      this.deleteHistoricoId = null;
      this.deleteHistoricoItemName = null;
      this.deleteType = null;
      this.bulkDeleteIds = [];
      $(this.$refs.modal_delete).modal("hide");
    },

    onBulkDeleteAlert(ids) {
      if (!ids || ids.length === 0) return;
      this.bulkDeleteIds = [...ids];
      this.deleteType = 'bulk-alert';
      $(this.$refs.modal_delete).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    onBulkDeleteHistorico(ids) {
      if (!ids || ids.length === 0) return;
      this.bulkDeleteIds = [...ids];
      this.deleteType = 'bulk-historico';
      $(this.$refs.modal_delete).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    deleteHistoricoAlerta(id) {
      const item = this.$refs.datatableHistorico.values.find(v => v.id === id);      
      this.deleteHistoricoId = id;
      this.deleteHistoricoItemName = item ? (item.userInfoAlertName) : null;
      this.deleteType = 'historico';
      
      $(this.$refs.modal_delete).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    toggleAlertStatus(item) {
      const statusText = item.active ? "desativado" : "ativado";
      
      this.urlPut(`/UserInfoAlert/toggle-status/${item.id}`)
        .then(() => {
          this.$refs.datatableCadastro.update();
          this.$refs.alert.show(
            "Sucesso",
            `Alerta ${statusText} com sucesso`,
            null,
            3000,
            "bg-success"
          );
        })
        .catch((error) => {
          console.error(`Erro ao ${item.active ? 'desativar' : 'ativar'} alerta:`, error);
          this.$refs.alert.show(
            "Erro",
            `Erro ao ${item.active ? 'desativar' : 'ativar'} alerta`,
            null,
            3000,
            "bg-danger"
          );
        });
    },

    openFilter() {
      $(this.$refs.modal_filter).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeFilter() {
      $(this.$refs.modal_filter).modal("hide");
    },

    applyFilters() {
      this.whereFilters = Object.assign({}, this.filters);
      this.$refs.datatableCadastro.applyFilters(this.whereFilters);
      this.closeFilter();
    },

    clearFilters() {
      this.filters = {};
      this.whereFilters = {};
      this.$refs.datatableCadastro.applyFilters({});
    },

    async carregarPropriedades() {
      try {
        // Admin carrega TODAS as propriedades do sistema usando endpoints Admin
        const urbanEndpoint = this.isAdmin ? '/PropriedadeAgricola/ReadUrbanAdmin' : '/PropriedadeAgricola/ReadUrban';
        const ruralEndpoint = this.isAdmin ? '/PropriedadeAgricola/ReadRuralAdmin' : '/PropriedadeAgricola/ReadRural';

        const [urbanResponse, ruralResponse] = await Promise.all([
          this.urlPost(urbanEndpoint, {
            limit: -1,
            offset: 0,
            orderby: { column: 'nome', type: 'ASC' },
            where: {}
          }, { contentType: 'application/json' }),
          this.urlPost(ruralEndpoint, {
            limit: -1,
            offset: 0,
            orderby: { column: 'nome', type: 'ASC' },
            where: {}
          }, { contentType: 'application/json' })
        ]);

        const urbanProperties = Array.isArray(urbanResponse.data.itens) ? urbanResponse.data.itens : [];
        urbanProperties.forEach(property => {
          property.type = 'urban';
        });

        const ruralProperties = Array.isArray(ruralResponse.data.itens) ? ruralResponse.data.itens : [];
        ruralProperties.forEach(property => {
          property.type = 'rural';
        });

        this.propriedades = [...urbanProperties, ...ruralProperties];
        this.propriedades.sort((a, b) => a.nome.localeCompare(b.nome));
      } catch (error) {
        console.error('Erro ao carregar propriedades:', error);
        this.$refs.alert?.show(
          "Erro",
          "Erro ao carregar propriedades",
          null,
          3000,
          "bg-danger"
        );
      }
    },

    async loadSharedDispositivos() {
      try {
        const user = this.getUser();
        const response = await this.urlGet(`/QRCode/SharedLinked/${user.id}`);
        
        // Filtrar apenas dispositivos premium (como no Report)
        const dispositivos = response.data.itens.filter(qrCode => qrCode.premium);
        
        this.dispositivos = dispositivos.map(dispositivo => ({
          id: dispositivo.id,
          nome: dispositivo.nomeDispositivo
        }));
      } catch (error) {
        console.error('Erro ao carregar dispositivos compartilhados:', error);
        this.$refs.alert?.show(
          "Erro",
          "Erro ao carregar dispositivos compartilhados",
          null,
          3000,
          "bg-danger"
        );
      }
    },

    async loadDispositivosByPropriedade(propriedadeId) {
      if (!propriedadeId) {
        this.dispositivos = [];
        this.alertForm.dispositivoId = "";
        return;
      }
      
      try {
        const response = await this.urlGet(`/QRCode/Linked/${propriedadeId}`);
        this.dispositivos = response.data.map(dispositivo => ({
          id: dispositivo.id,
          nome: dispositivo.nomeDispositivo
        }));
      } catch (error) {
        console.error('Erro ao carregar dispositivos:', error);
        this.$refs.alert?.show(
          "Erro",
          "Erro ao carregar dispositivos",
          null,
          3000,
          "bg-danger"
        );
      }
    }
  }
};
</script>

<style scoped>
.page-container {
  margin: 0 auto;
  padding: 20px;
}
.section {
  margin-bottom: 20px;
}

.form-modal-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
}

:deep(.table) {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

:deep(.table th) {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  padding: 12px;
  font-weight: 600;
}

:deep(.table td) {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
}

:deep(.table tr:last-child td) {
  border-bottom: none;
}

:deep(.btn-primary) {
  background-color: #28a745;
  border-color: #28a745;
}

:deep(.btn-primary:hover) {
  background-color: #218838;
  border-color: #1e7e34;
}

.modal-backdrop {
  z-index: 1050 !important;
}

.modal {
  z-index: 1051 !important;
}

/* Remover padding do container no mobile para ganhar espaço */
@media (max-width: 768px) {
  .page-container {
    padding: 10px 5px !important;
  }
}
</style>
